import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";
import MessageQuill from "../Message/MessageQuill";
import moment from "jalali-moment";

const AddnewsupportTicket = ({ close, data, getTicket }) => {
    const date = new Date();

    const [dateTime, setDateTime] = useState("");

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        const date = moment().locale("fa").format("ddd DD MMMM YYYY");
        const time = moment().locale("fa").format("HH:mm:ss");
        const dateAndTime = `${date} ساعت ${time}`;
        setDateTime(dateAndTime);
    }, []);

    const [call, setCall] = useState();
    const [title, setTitle] = useState();
    const [description, setDescription] = useState();

    // const getTicket = useFetch({
    //     method: "GET",
    //     url: `TicketService/tickets`,
    //     noHeader: false,
    //     trigger: true,
    //     setter: setTickets,
    // });

    const newTicket = useFetch({
        method: "POST",
        url: `TicketMessageService/send_message`,
        noHeader: false,
        caller: getTicket,
        trigger: false,
        data: call,
    });

    const submitForm = () => {
        const formData = new FormData();

        formData.append("subject", title);
        formData.append("text", description);
        setCall(formData);
        newTicket.reFetch();
    };

    useEffect(() => {
        newTicket.status === 201 && close(false);
    }, [newTicket]);

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[16px]">
                تیکت پشتیبانی
            </h3>
            <p className=" text-center text-[#212121E5] text-[14px] my-8">
                {dateTime}
            </p>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter title",
                        },
                    }}
                    type="text"
                    name="title"
                    control={control}
                    placeholder="موضوع"
                    className="input border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] "
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <MessageQuill
                    placeholder="توضیحات *"
                    value={description}
                    setValue={setDescription}
                />

                <BtnPrimary
                    className="py-[2rem] px-[6rem] flex mr-auto "
                    text="ارسال تیکت"
                />
            </form>
        </div>
    );
};

export default AddnewsupportTicket;
